import { api } from './api';

/** A frozen, shareable view of a conversation, brief, or compose output.
 *  The payload shape is caller-defined; the SharedSnapshotPage falls back
 *  to a JSON pretty-print if it doesn't recognize the `kind`. */
export interface Snapshot {
  id: string;
  workspaceId?: string;
  conversationId?: string | null;
  label: string;
  payload: unknown;
  createdAt: string;
  expiresAt: string | null;
}

export interface CreateSnapshotBody {
  /** Required — what to preserve in the frozen view. */
  payload: Record<string, unknown>;
  /** Optional human label; defaults to "Snapshot YYYY-MM-DD" server-side. */
  label?: string;
  /** Optional TTL in days; null = no expiry. */
  ttlDays?: number;
  /** Optional link back to the source conversation. */
  conversationId?: string;
}

export const snapshotsApi = {
  async list(workspaceId: string): Promise<Snapshot[]> {
    const r = await api.get<Snapshot[]>(`/api/workspaces/${workspaceId}/snapshots`);
    return r.data;
  },
  async create(workspaceId: string, body: CreateSnapshotBody): Promise<Snapshot> {
    const r = await api.post<Snapshot>(`/api/workspaces/${workspaceId}/snapshots`, body);
    return r.data;
  },
  /** Public — no auth required. */
  async getPublic(id: string): Promise<Snapshot> {
    const r = await api.get<Snapshot>(`/api/snapshots/${id}`);
    return r.data;
  },
  publicUrl(id: string): string {
    return `${window.location.origin}/share/${id}`;
  },
};
